import React from 'react'
import { isEmpty } from 'lodash'

import { WrapperInfoLink, TextInfoLink, ButtonAddress } from './styles'
import {
  textActivateTagHelper,
  buttonActivateTagHelper,
  buttonNotArrived,
  textNotArrived
} from './data.json'

import ArrowRight from '../../elements/Icon/arrow-right'

const ActivateTagHelper = props => (
  <WrapperInfoLink>
    <TextInfoLink>{textActivateTagHelper}</TextInfoLink>

    <ButtonAddress onClick={() => props.history.push('/identificadores/ativacao')}>
      {buttonActivateTagHelper}
      <ArrowRight width="16" height="16" />
    </ButtonAddress>
  </WrapperInfoLink>
)

const NotArrivedHelper = props => (
  <WrapperInfoLink>
    <TextInfoLink>{textNotArrived}</TextInfoLink>

    <ButtonAddress onClick={() => props.history.push('/primeiro-acesso/extravio')}>
      {buttonNotArrived}
      <ArrowRight width="16" height="16" />
    </ButtonAddress>
  </WrapperInfoLink>
)

export const renderNotArrivedHelper = (order, type, history) => {
  const trackerStatus = order.tracker[0].status.toUpperCase()
  const paymentStatus = order.payment.status.toUpperCase()
  if (
    (trackerStatus === 'DEVOLVIDO' && paymentStatus === 'PAGAMENTO APROVADO') ||
    (trackerStatus === 'DEVOLVIDO' && type === 'pos') ||
    (trackerStatus === 'CANCELADO' && type === 'pos') ||
    (trackerStatus === 'ENTREGUE' && isEmpty(paymentStatus)) ||
    (trackerStatus === 'DEVOLVIDO' && isEmpty(paymentStatus)) ||
    (trackerStatus === 'CANCELADO' && isEmpty(paymentStatus))
  ) {
    return <NotArrivedHelper history={history} />
  }
  return null
}

export const renderActivateTagHelper = (order, type, history) => {
  const trackerStatus = order.tracker[0].status.toUpperCase()
  const paymentStatus = order.payment.status.toUpperCase()
  if (
    (isEmpty(order.tracker.status) && paymentStatus === 'PAGAMENTO APROVADO') ||
    (trackerStatus === 'EM TRANSPORTE' && paymentStatus === 'PAGAMENTO APROVADO') ||
    (trackerStatus === 'CANCELADO' && paymentStatus === 'PAGAMENTO APROVADO') ||
    (trackerStatus === 'ENVIADO' && paymentStatus === 'PAGAMENTO APROVADO') ||
    (trackerStatus === 'EXTRAVIADO' && paymentStatus === 'PAGAMENTO APROVADO') ||
    (trackerStatus === 'DEVOLVIDO' && paymentStatus === 'PAGAMENTO APROVADO') ||
    (trackerStatus === 'EM TRANSPORTE' && type === 'pos') ||
    (trackerStatus === 'CANCELADO' && type === 'pos') ||
    (trackerStatus === 'ENVIADO' && type === 'pos') ||
    (trackerStatus === 'EXTRAVIADO' && type === 'pos') ||
    (trackerStatus === 'DEVOLVIDO' && type === 'pos')
  ) {
    return <ActivateTagHelper history={history} />
  }
  return null
}



// WEBPACK FOOTER //
// ./src/app/pages/FirstAccessFollowRequestDetail/helpers.js